import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractFncGroupGuard } from './AbstractFncGroupGuard';
import { AuthService } from '../../auth/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BINARY_ASSESSMENT_FNC_GROUPS, FncGroup } from '../../auth/FncGroup';

@Injectable({
  providedIn: 'root'
})
export class CanOpenAdminAreaGuard extends AbstractFncGroupGuard  {

  constructor(
    authService: AuthService,
    snackBar: MatSnackBar,
    router: Router,
  ) {
    super([
      FncGroup.ADMIN,
      FncGroup.PROCESS_ADMIN,
      ...BINARY_ASSESSMENT_FNC_GROUPS,
    ], authService, snackBar, router);
  }

}
